/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { AsessFilterDto, SeasonDto, SpecialService } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG } from '_metronic/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'
import moment from 'moment'
import clsx from 'clsx'


const SpecialPage: FC = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<string[][]>([])
    const [footData, setFootData] = useState<string[][]>([])

    const [searchParam, setSearchParam] = useState<AsessFilterDto>()

    const columnDef: ColDef<string[]>[] = [
        {
            label: 'Id',
            renderItem: ({ item, index }) => item[index],
            hidden: true
        },
        {
            label: 'วันที่',
            width: "30%",
            renderItem: ({ item, index }) => item[index],
        },
        {
            label: 'รายละเอียด',
            width: "30%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: 'คะแนน',
            width: "30%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: '',
            renderItem: ({ item }) => <>
                <div className='text-center'>
                    {item[5] === "ADD:" ? <></> : <button
                        type='button'
                        onClick={(e) => {
                            const key = tableSetting.primaryKey(item)
                            navigate('/special-detail/' + key[0])
                        }
                        }
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3'
                        />
                    </button>}



                </div>
            </>,
        },
    ]

    const footerDef: ColDef<string[]>[] = [
        {
            label: 'วันที่',
            width: "30%",
            renderItem: ({ item, index }) => item[index],
        },
        {
            label: 'รายละเอียด',
            width: "30%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: 'คะแนน',
            width: "30%",
            renderItem: ({ item, index }) => item[index]
        },
        {
            label: '',
            renderItem: () => <></>,
        },
    ]

    const tableSetting: TableSetting<string[]> = {
        showColAction: false,
        primaryKey: (item: string[]) => item,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: true,
        showFilter: false,
        showSearch: false,
        btnAddText: 'เพิ่มคะแนนพิเศษ',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/special-detail/new')
    }

    useEffect(() => {
        const load = () => {
            if (lastSeason) {
                SpecialService.Search({
                    startDate: lastSeason.periodStart,
                    endDate: lastSeason.periodEnd,
                }).then((result) => {
                    const row = result.data.result
                    setData(row.rows)
                    setFootData(row.footers)
                })
            }
        }
        load()
    }, [lastSeason, reload])

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>
                <div className='card-header cursor-pointer'>

                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>

                </div>
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            footers={footerDef}
                            data={data as []}
                            dataFooter={footData as []}
                        />
                        {/* end::Table */}
                    </div>

                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { SpecialPage }
